import React from "react";
import Uploadcv from "./Uploadcv";

export default function CompetenceRight() {
  return (
    <div>
      <img src="/images/cv.png" className="h-[40rem]" />
      <Uploadcv/>
    </div>
  );
}
